import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {enableUniqueIds} from '@cred/shared/unique-id'
import Font from '@cred/react-font'
import {Field} from 'redux-form'
import emitOnChange from '@cred/react-analytics/hoc/emitOnChange'
import defaultStyles from './themes/default/styles.module.scss'
import fox1 from './themes/fox1/styles.module.scss'
import thebalance1 from './themes/thebalance1/styles.module.scss'
import investopedia1 from './themes/investopedia1/styles.module.scss'
import forbes1 from './themes/forbes1/styles.module.scss'
import credible3 from './themes/credible3/styles.module.scss'
import withStyles from '@cred/react-theme'

class Radio extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    withBorder: PropTypes.bool,
    radioType: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    description: PropTypes.string,
    showBlockLabel: PropTypes.bool
  }
  static defaultProps = {
    withBorder: false,
    radioType: 'radio',
    showBlockLabel: false
  }

  static displayName = 'Radio'

  constructor(props) {
    super(props)
    enableUniqueIds(this)
  }

  render() {
    const {id, ...props} = this.props

    return (
      <Field type="radio" component={radioButtonWithAnalytics} id={id || this.nextUniqueId()} {...props}/>
    )
  }
}

const radioInput = field => {
    const {styles, theme, radioType, withBorder, className} = field

    return (
      <div className={[styles[radioType], className, field.description ? styles.withDescription : ''].join(' ')}>
        <input
          hidden
          type="radio"
          id={field.id}
          disabled={field.disabled}
          {...field.input}
        />
        <div
          className={[styles.radioInputWrapper, withBorder ? styles.withBorder : ''].join(' ')}
          ref={field.forwardRef}
          key={field.id}
          tabIndex={-1}
          onKeyPress={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              const {input: {value, onChange}} = field

              onChange(value)
            }
          }}
        >

          {field.radioType === 'checkbox' ?
            <Font element="label" htmlFor={field.id}>
              <span className={styles.checkboxBox}>
                <span className={styles.checkboxIcon}>
                  <i className="cred-icon icon-check"/>
                </span>
              </span>
              <span className={[styles.checkboxLabel, 'hidden-xs', 'hidden-sm'].join(' ')}>
                {field.label}
              </span>
              <span className={[styles.checkboxLabel, 'hidden-md', 'hidden-lg', 'hidden-xl'].join(' ')}>
                {field.mobileLabel || field.label}
              </span>
            </Font>
            :
            theme === 'credible3' ?
              <label htmlFor={field.id}>
                <div>
                  <Font element="span" weight="semiBold" className={styles.radioLabel}>{field.label}</Font>
                  <Font element="span" type="bodySmall" className={styles.description}>{field.description}</Font>
                </div>
                <i className="cred-icon icon-chevron-right"/>
              </label>
              :
              <Font element="label" htmlFor={field.id} className={field.showBlockLabel ? styles.blockLabel : ''}>
                <span className={styles.radioBox}>
                  <span className={styles.radioIcon}/>
                </span>
                <div>
                  <span className={[styles.radioLabel, field.showBlockLabel ? styles.blockLabel : ''].join(' ')}>{field.label}</span>
                </div>
              </Font>
          }
        </div>
      </div>
    )
  },
  radioButtonWithAnalytics = /*#__PURE__*/ emitOnChange(radioInput)

export {Radio as RadioNoHoc, radioInput}

export default /*#__PURE__*/ withStyles(
  defaultStyles, {
    fox1,
    thebalance1,
    investopedia1,
    forbes1,
    credible3
  }
)(Radio)
